import MovieCard from '@/components/feature/MovieCard';
import { allMovies } from '@/mocks/movies';

export default function FeaturedSection() {
  const hotMovies = allMovies.filter(m => m.isHot).slice(0, 4);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              热门推荐
            </h2>
            <p className="text-foreground-500 text-sm">精选全网最受欢迎的影视内容</p>
          </div>
          <a
            href="/category/movie"
            className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-product-shop>
          {hotMovies.map(movie => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </div>
    </section>
  );
}